/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { TPages } from '../types/appTypes'
import PageItem from './PageItem'
import { ChevronDoubleDownIcon, ChevronDoubleUpIcon } from '@heroicons/react/outline'

type TPageListProps = {
  pages: TPages
}

const PageList = ({ pages }: TPageListProps) => {
  const [wrapperHeight, setWrapperHeight] = useState<number>(window.innerHeight - 200)

  useEffect(() => {
    setWrapperHeight(window.innerHeight - 230)
  }, [window.innerHeight])

  const handleScrollToFirstPage = () => {
    document.getElementById('page-list').scrollTop = 0
  }

  const handleScrollToLastPage = () => {
    const elementId = `${pages[pages.length - 1].documentId}_${pages[pages.length - 1].pageNo}`
    const topPos = document.getElementById(elementId).offsetTop
    document.getElementById('page-list').scrollTop = topPos
  }
  return (
    <div className="flex h-full min-w-0" style={{ flex: '1 1 auto' }}>
      <div className="hidden md:flex flex-col justify-between py-6 px-4 flex-shrink-0 bg-gray-50 border-r border-gray-200">
        <div className="rounded-full p-3 bg-acs-blue-100 hover:bg-acs-blue-200 hover:cursor-pointer shadow-sm transition-colors" onClick={handleScrollToFirstPage}>
          <ChevronDoubleUpIcon className="w-6 h-6 text-acs-blue-500" />
        </div>
        <div className="rounded-full p-3 bg-acs-blue-100 hover:bg-acs-blue-200 hover:cursor-pointer shadow-sm transition-colors" onClick={handleScrollToLastPage}>
          <ChevronDoubleDownIcon className="w-6 h-6 text-acs-blue-500" />
        </div>
      </div>
      <div
        id="page-list"
        className="flex-1 min-w-0 overflow-auto p-4 md:p-6 bg-gray-100"
        style={{ scrollBehavior: 'smooth' }}
      >
        <div className="w-full md:w-max">
          {pages.map((page) => {
            return <PageItem key={page.pageNo} page={page} />
          })}
        </div>
      </div>
    </div>
  )
}

export default PageList
